module.exports = __webpack_public_path__ + "assets/on-charging-pick.f5118e7b.svg";